module.exports = __webpack_public_path__ + "img/ex7.65006ba6.png";